import React from "react";
import { Link } from "react-router-dom";
import edfocilogo from "../../../assets/images/logo.png";
import edsiderlogo from "../../../assets/images/edsiderlogo.png";
import cmclogo from "../../../assets/images/mid.png";
import RAlogo from "../../../assets/images/royal-logo.png";
import CGClogo from "../../../assets/images/cgc-logo.png";
import IEA_logo from "../../../assets/images/IEA_logo.png";
import AEHSlogo from "../../../assets/images/AEHS-Logo.png";
import SIT_logo from "../../../assets/images/SIT_logo.png";
import config from "../../../helper/config";
import { customerConstants } from "../../../helper/constants.js";
import { Margin, Padding } from "@mui/icons-material";

const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag;
};

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  //Creates the label for the button of aside menu
  headerLabelMaker = () => {
    const sessionUserName = sessionStorage.getItem("username");

    if (sessionUserName) {
      const names = sessionUserName.split(" ");
      const initials = names.map((name) => {
        if (name.length > 0) {
          return name[0].toUpperCase();
        } else {
          return ""; // Handle empty names if necessary
        }
      });
      const result = initials.join("");
      return result;
    } else {
      return ""; // Handle the case where sessionUserName is not available
    }
  };

  render() {
    const customer = getCustomerFeatureFlag();
    let logo, logoStyle, logoStyle2 = false;
    switch (customer) {
      case customerConstants.EXO_CUSTOMER1:
        logo = edsiderlogo;
        logoStyle = { width: "140px", height: "auto" };
        break;
      case customerConstants.EXO_CUSTOMER2:
        logo = cmclogo;
        logoStyle = { width: "190px", height: "auto" };
        break;
      case customerConstants.EDF_CUSTOMER2:
        logo = RAlogo;
        logoStyle = { width: "40px", height: "auto" };
        break;
      case customerConstants.EDF_CUSTOMER3:
        logo = CGClogo;
        logoStyle = { width: "64px", height: "auto", Padding: '2px' };
        logoStyle2 = true;
        break;
      case customerConstants.EDF_CUSTOMER4:
        logo = AEHSlogo;
        logoStyle = { width: "150px", height: "auto", Padding: '2px' };
        logoStyle2 = true;
        break;
      case customerConstants.EDF_CUSTOMER5:
        logo = IEA_logo;
        logoStyle = { width: "150px", height: "auto", Padding: '2px' };
        break;
      case customerConstants.EDF_CUSTOMER6:
      logo = SIT_logo;
      logoStyle = { width: "106px", height: "auto", Padding: '2px' };
      break;
      default:
        logo = edfocilogo;
        logoStyle = { width: "140px", height: "auto" };
        break;
    }
    return (
      <div id="kt_header" className="header header-fixed">
        {/* begin::Container */}
        <div className="container-fluid d-flex align-items-stretch justify-content-between">
          {/* begin::Header Menu Wrapper */}
          <div
            className={logoStyle2 === false ? 'header-menu-wrapper header-menu-wrapper-left' : 'header-menu-wrapper-left'}
            id="kt_header_menu_wrapper"
          >

            {/* begin::Info */}
            <div className="d-flex align-items-center flex-wrap mr-2 header-title">
              {/* begin::Actions */}
              {/* <div className="subheader-separator subheader-separator-ver mt-2 mb-2 mr-4 bg-gray-200"></div> */}
              {/* <span className="text-muted font-weight-bold mr-4"></span> */}
              <div className="brand-logo brand-web">
                {/* <img alt="Logo" className="logo" src="../../../../public/assets/media/logos/logo-light.png" /> */}
                <img
                  alt="Logo"
                  className="logo"
                  src={logo}
                  style={logoStyle}
                />
              </div>
              {/* end::Actions */}
            </div>
            {/* end::Info */}
          </div>

          {/* end::Header Menu Wrapper */}

          {/* begin::Topbar */}
          <div className="topbar">
            {/* begin::User */}
            <div className="topbar-item">
              <div
                className="btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2"
                id="kt_quick_user_toggle"
              >
                <span className="symbol symbol-35 symbol-primary">
                  <span className="symbol-label font-size-h5 font-weight-bold">
                    {this.headerLabelMaker()}
                  </span>
                </span>
              </div>
            </div>
            {/* end::User */}
          </div>
          {/* end::Topbar */}
        </div>
        {/* end::Container */}
      </div>
    );
  }
}

export default Header;
